import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { DragSource } from 'react-dnd'
import { BOARD_DRAG_TYPES_CARD } from '../../../constants/boardDragTypes'
import Card from './Card'
import classNames from 'classnames'
import { getEmptyImage } from 'react-dnd-html5-backend'
import { isGeneratedId } from '../../../store/addTask'
import { toastr } from 'react-redux-toastr'
import localize from '../../../higherOrderComponents/localize'

const cardSource = {
  beginDrag(props, monitor, component) {
    props.setPlaceHolder({
      laneId: props.laneId,
      nextTaskId: props.task.id,
      sourceLaneId: props.laneId,
      taskId: props.task.id
    })
    return {
      laneId: props.laneId,
      task: props.task,
      index: props.index,
      height: component.card.clientHeight
    }
  },
  canDrag(props, monitor) {
    return props.task.actions.update
  },
  isDragging(props, monitor) {
    return props.task.id === monitor.getItem().task.id
  },
  endDrag(props, monitor, component) {
    props.onTaskDropped()
  }
}

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview()
  }
}

function getStyles(props) {
  return {
    opacity: props.isDragging ? 0 : 1,
    height: props.isDragging ? 0 : '',
    overflow: props.isDragging ? 'hidden' : ''
  }
}

const getBoundingRectangle = (card) => {
  const boundingRect = card.getBoundingClientRect()
  return {
    top: boundingRect.top,
    bottom: boundingRect.bottom
  }
}

const isCustomDragImageSupported = () => typeof DataTransfer.prototype.setDragImage === 'function'

class DragCard extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isDragError: false
    }
  }

  removeDragError = () => {
    this.setState({ isDragError: false })
    document.removeEventListener('mouseup', this.removeDragError)
  }

  triggerDragError = () => {
    this.setState({ isDragError: true })
    document.addEventListener('mouseup', this.removeDragError)
    toastr.error('', this.props.localize('tasks.Message_NoPermission'))
  }

  onDragStart = () => {
    if (!this.props.task.actions.update) {
      this.triggerDragError()
    }
  }

  componentDidMount() {
    this.props.connectDragPreview(getEmptyImage(), { captureDraggingState: !isCustomDragImageSupported() })
    this.props.setTaskOffset(this.props.task.id, getBoundingRectangle(this.card))
  }

  componentWillUnmount() {
    this.props.setTaskOffset(this.props.task.id, null)
  }

  componentDidUpdate() {
    this.props.setTaskOffset(this.props.task.id, getBoundingRectangle(this.card))
  }

  render() {
    const { connectDragSource, task } = this.props
    if (isGeneratedId(task.id)) {
      return <div ref={(card) => this.card = card} style={getStyles(this.props)}><Card task={task} notDraggable /></div>
    }

    return connectDragSource(
      <div
        ref={(card) => this.card = card}
        onDragStart={this.onDragStart}
        className={classNames({ 'drag-card-error' : this.state.isDragError })}
        style={getStyles(this.props)}>
        <Card task={task} />
      </div>
    )
  }
}

DragCard.propTypes = {
  localize: PropTypes.func,
  task: PropTypes.object.isRequired,
  laneId: PropTypes.string.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  onTaskDropped: PropTypes.func.isRequired,
  setTaskOffset: PropTypes.func.isRequired,
  setPlaceHolder: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired // Not used, but forces an update on change
}

export default localize(DragSource(BOARD_DRAG_TYPES_CARD, cardSource, collect)(DragCard))



// WEBPACK FOOTER //
// ./src/routes/Board/components/DragCard.js